import { throwError } from "@/lib/throwError";
import { get } from "@/services/axiosUitils";

const basePath = "/pts_app/onboardingmail/";

export interface OnboardingMailResponse {
  message?: string;
  project_id?: string;
  project_name?: string;
  to?: string;
  client_name?: string;
  pdf_filename?: string;
  [key: string]: unknown;
}

class PtsOnboardingMailService {
  /**
   * GET /pts_app/onboardingmail/?project={projectId}
   */
  sendOnboardingMail = async (
    projectId: string
  ): Promise<OnboardingMailResponse> => {
    if (!projectId) {
      throwError("Project id is required", "PtsOnboardingMailService");
    }
    return await get<OnboardingMailResponse>(basePath, {
      params: { project: projectId },
    });
  };
}

export default new PtsOnboardingMailService();
